import { render, staticRenderFns } from "./PageLink.vue?vue&type=template&id=60c31de8&scoped=true&"
import script from "./PageLink.vue?vue&type=script&lang=js&"
export * from "./PageLink.vue?vue&type=script&lang=js&"
import style0 from "./PageLink.vue?vue&type=style&index=0&id=60c31de8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c31de8",
  null
  
)

export default component.exports